import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getGoToBrandReferralsCTA } from "./shared";

export const BrandReferralStatusIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (_context) => {
      return BRAND_REFERRALS_STATUS_TITLE(strictLocalize);
    },

    descriptionBuilder(_context) {
      return [BRAND_REFERRALS_STATUS_DESCRIPTION(strictLocalize)];
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getGoToBrandReferralsCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getGoToBrandReferralsCTA(context, strictLocalize)?.getLink?.();
      },
    },
  };
};

const BRAND_REFERRALS_STATUS_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "How to check the status of brand referrals",
  });

const BRAND_REFERRALS_STATUS_DESCRIPTION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "Go to “Refer brands” in “Account”, and select the “Invited” tab to check the status of a brand’s application. Note that we can only share additional details about a brand’s application directly with the brand itself.",
  });
